export const Card1 = [
  {
    id: 1,
    title: `Convenient Scheduling Options`,
    img: `https://www.cloudsocial.io/wp-content/uploads/image/Publish-Calendar.png`,
    desc: `Schedule social media posts through several social media handles on multiple channels. Customize post
    frequency, timings, and channels for maximum impact and engagement. Gain a holistic view of your
    content plan with our cross-platform social media calendar.`,
  },
];

export const Card2 = [
  {
    id: 2,
    title: `Optimized Engagement With Omnibox`,
    img: `https://www.cloudsocial.io/wp-content/uploads/image/Omnibox-Ticket&comments.png`,
    desc: `Respond to queries, comments, posts, and feedback from multiple social accounts in real-time. Gain
    brownie points from customers by always staying connected using our social media tools.`,
  },
];

export const Card3 = [
  {
    id: 3,
    title: `Analytics & Reports`,
    img: `https://www.cloudsocial.io/wp-content/uploads/image/Analytics.png`,
    desc: `Let data-driven insights guide you towards success. CloudSocial provides you intuitive reports to help you
    understand consumer preferences and customize your branding strategy accordingly.`,
  },
];

export const SliderImages = [
  {
    id: 1,
    title: "CRM",
    link: "#analysis",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/sliderImages/CRM.svg",
    set1: "https://www.cloudsocial.io/wp-content/uploads/image/sliderImages/crm.webp",
    srcset:
      "./sliderImage/crm655.jpg 655w,./sliderImage/crm984.jpg 984w,./sliderImage/crm1248.jpg 1248w",
    heading: "SOCIAL CRM",
    desc: "Respond to direct messages, tweets, comments, reviews & emails",
  },
  {
    id: 2,
    title: "SentimentAnalysis",
    link: "#analysis",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/sliderImages/Sentiment.svg",
    set1: "https://www.cloudsocial.io/wp-content/uploads/image/sliderImages/Sentiment.webp",
    srcset:
      "./sliderImage/sentiment655.jpg 655w,./sliderImage/sentiment984.jpg 984w,./sliderImage/sentiment1248.jpg 1248w",
    heading: "SENTIMENT ANALYSIS",
    desc: "Know how customers feel about your brand",
  },
  {
    id: 3,
    title: "Calendar",
    link: "#calender",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/sliderImages/Calendar.svg",
    set1: "https://www.cloudsocial.io/wp-content/uploads/image/sliderImages/Calendar.webp",
    srcset:
      "./sliderImage/calander655.jpg 655w,./sliderImage/calander984.jpg 984w,./sliderImage/calander1248.jpg 1248w",

    heading: "SOCIAL MEDIA CALENDAR",
    desc: "Single view of scheduled social media posts",
  },
  {
    id: 4,
    title: "AdvancedListen",
    link: "#video",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/sliderImages/AdvancedListen.svg",
    set1: "https://www.cloudsocial.io/wp-content/uploads/image/sliderImages/AdvancedListen.webp",
    srcset:
      "./sliderImage/listen655.jpg 655w,./sliderImage/listen984.jpg 984w,./sliderImage/listen1248.jpg 1248w",
    heading: "ADVANCED LISTENING",
    desc: "Crawl for insights with Boolean search queries",
  },
  {
    id: 5,
    title: "GoogleMyBusiness",
    link: "#gmb",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/sliderImages/GoogleMyBusiness.svg",
    set1: "https://www.cloudsocial.io/wp-content/uploads/image/sliderImages/Gmb.webp",
    srcset:
      "./sliderImage/gmb655.jpg 655w,./sliderImage/gmb984.jpg 984w,./sliderImage/gmb1248.jpg 1248w",
    heading: "GOOGLE MY BUSINESS",
    desc: "Post content and respond to reviews and ratings",
  },

  {
    id: 6,
    title: "Dashboard",
    link: "#dashboard",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/sliderImages/Dashboard.svg",
    set1: "https://www.cloudsocial.io/wp-content/uploads/image/sliderImages/Dashboard.webp",
    srcset:
      "./sliderImage/dashboard655.jpg 655w,./sliderImage/dashboard984.jpg 984w,./sliderImage/dashboard1248.jpg 1248w",
    heading: "CUSTOMISABLE DASHBOARD",
    desc: "Monitor the Social metrics which matter the most",
  },
  {
    id: 7,
    title: "Instagram",
    link: "#video",
    img: "./sliderImage/gram1248.jpg",
    set1: "https://www.cloudsocial.io/wp-content/uploads/image/sliderImages/Instagram.webp",
    heading: "INSTAGRAM DIRECT PUBLISHING",
    desc: "Publish content directly on Instagram through CloudSocial",
    srcset:
      "./sliderImage/gram655.jpg 655w,./sliderImage/gram984.jpg 984w,./sliderImage/gram1248.jpg 1248w",
  },
  {
    id: 8,
    title: "Pixabay",
    link: "#video",
    img: "./sliderImage/bay1248.jpg",
    set1: "https://www.cloudsocial.io/wp-content/uploads/image/sliderImages/Pixabay.webp",
    heading: "PIXABAY",
    desc: "Choose the perfect image from repository of 2.3 million+ for your next social post",
    srcset:
      "./sliderImage/bay655.jpg 655w,./sliderImage/bay984.jpg 984w,./sliderImage/bay1248.jpg 1248w",
  },
  // {
  //   id: 7,
  //   title: "CloudInsights",
  //   link: "pricing",
  //   img: "https://www.cloudsocial.io/wp-content/uploads/image/sliderImages/Cloudinsights.png",
  //   set1:
  //     "https://www.cloudsocial.io/wp-content/uploads/image/sliderImages/Cloudinsights_weamax_c_scale,w_200.png 300w",
  // },
  // {
  //   id: 8,
  //   title: "CloudInfluence",
  //   link: "pricing",
  //   img: "https://www.cloudsocial.io/wp-content/uploads/image/sliderImages/Cloudinfluence.png",
  // },
];

export const socialMedia = [
  {
    id: 1,
    title: "Analytics",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/analysis.svg",
    desc: `Track your social media performance and customize your branding strategy using CloudSocial's detailed insights and analytics reports.`,
    listen: "https://www.youtube.com/embed/k4HtN7sOIis?autoplay=1&mute=1",
    // imgUrl:
    //   "https://mlvlk7qibkfe.i.optimole.com/w:383/h:294/q:auto/https://www.cloudsocial.io/wp-content/uploads/2019/05/ytv5.jpg",
    imgUrl:
      "https://mlvlk7qibkfe.i.optimole.com/w:383/h:294/q:auto/https://www.cloudsocial.io/wp-content/uploads/2019/05/ytv2.jpg",
  },
  {
    id: 2,
    title: "Publish",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/publish.svg",
    desc: `Create, schedule, and post your content on multiple social channels from the CloudSocial platform to maximize visibility and brand awareness. Remain omnipresent on all social media channels 24x7.`,
    listen: "https://www.youtube.com/embed/ICKlAb26MEg?autoplay=1&mute=1",
    imgUrl:
      "https://mlvlk7qibkfe.i.optimole.com/w:383/h:294/q:auto/https://www.cloudsocial.io/wp-content/uploads/2019/05/ytv3.jpg",
  },
  {
    id: 3,
    title: "Listen",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/listen.svg",
    desc: `Stay updated on the latest social media trends and events. Monitor all your social channels and spot prospects from miles away with custom keywords using Social Media Listening.`,
    listen: `https://www.youtube.com/embed/fRERBoxd5Uw?autoplay=1&mute=1`,
    // imgUrl:
    //   "https://mlvlk7qibkfe.i.optimole.com/w:auto/h:auto/q:auto/https://www.cloudsocial.io/wp-content/uploads/2020/04/youtube-omnibox.jpg",
    imgUrl:
      "https://mlvlk7qibkfe.i.optimole.com/w:383/h:294/q:auto/https://www.cloudsocial.io/wp-content/uploads/2019/05/ytv9.jpg",
  },
  {
    id: 4,
    title: "Omnibox",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/omnibox.svg",
    desc: ` Engage with customers and prospects across numerous social media channels from our integrated Omnibox console. Manage and streamline your social media teams with approval workflows.`,
    listen: `https://www.youtube.com/embed/F9TZoFH14X4?autoplay=1&mute=1`,
    imgUrl:
      "https://mlvlk7qibkfe.i.optimole.com/w:383/h:294/q:auto/https://www.cloudsocial.io/wp-content/uploads/2019/05/ytv12.jpg",
  },
];

// export const socialIcon1 = [
//   {
//     id: 1,
//     title: "Facebook",
//     img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/facebook.svg",
//     content: "Profile, Page, Group, Messenger, Ad Manager",
//   },
//   {
//     id: 2,
//     title: "Instagram",
//     img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/instagram.svg",
//   },
//   {
//     id: 3,
//     title: "LinkedIn",
//     img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/linkedin.svg",
//   },
//   {
//     id: 4,
//     title: "Youtube",
//     img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/youtube.svg",
//   },
//   {
//     id: 5,
//     title: "Twitter",
//     img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/twitter.svg",
//   },

//   {
//     id: 6,
//     title: "Google My Business",
//     img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/Gmb.svg",
//   },
//   {
//     id: 7,
//     title: "E-mail",
//     img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/mail.svg",
//   },
// ];

export const socialIcon = [
  {
    id: 1,
    title: "Facebook",
    alt: "facebook",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/facebook.svg",
    // content: "Profile, Page, Group, Messenger, Ad Manager",
    content: "Publishing, DM",
  },
  {
    id: 2,
    title: "Youtube",
    alt: "youtube",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/youtube.svg",
    // content: "Channel",
    content: "Publishing, Listening",
  },
  {
    id: 3,
    title: "Instagram",
    alt: "instagram",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/Instagram.svg",
    // content: "Page",
    content: "Publishing, DM, Listening",
  },
  {
    id: 4,
    title: "TikTok",
    alt: "tiktok",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/TikTok.svg",
    // content: "Page",
    content: "Publishing",
  },
  {
    id: 5, 
    title: "LinkedIn",
    alt: "linkedIn",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/linkedin.svg",
    // content: "Page",
    content: "Publishing",
  },
  {
    id: 6,
    title: "Pinterest",
    alt: "pinterest",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/pinterest.svg",
    // content: "Page",
    content: "Publishing",
  },
  {
    id: 7,
    title: "Twitter",
    alt: "twitter",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/twitter.svg",
    // content: "Profile, DM",
    content: "Publishing, DM, Listening",
  },
  {
    id: 8,
    title: "Google My Business",
    alt: "gmb",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/Gmb.svg",
    // content: "Page",
    content: "Publishing",
  },
  {
    id: 9,
    title: "Medium",
    alt: "e-mail",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/Medium-Logo-Black-RGB_300x80.svg",
    // content: "Page",
    content: "Publishing",
  },
  {
    id: 10,
    title: "E-mail",
    alt: "e-mail",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/mail.svg",
    // content: "E-mail",
    content: "Responding",
  },
];

export const IntegrationIcon = [
  {
    id: 1,
    title: "Facebook",
    alt: "facebook",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/facebook.svg",
    content: "Publishing + DM",
  },
  {
    id: 2,
    title: "Youtube",
    alt: "youtube",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/youtube.svg",
    content: "Publishing + Listening",
  },
  {
    id: 3,
    title: "Instagram",
    alt: "instagram",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/Instagram.svg",
    content: "Publishing + DM + Listening",
  },
  {
    id: 4,
    title: "TikTok",
    alt: "tiktok",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/TikTok.svg",
    content: "Publishing",
  },
  {
    id: 5,
    title: "LinkedIn",
    alt: "linkedin",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/linkedin.svg",
    // img:
    //   "https://www.cloudsocial.io/wp-content/uploads/image/icon/LinkedIn.svg",
    content: "Publishing",
  },
  {
    id: 6,
    title: "Pinterest",
    alt: "pinterest",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/pinterest.svg",
    // content: "Page",
    content: "Publishing",
  },
  {
    id: 7,
    title: "Twitter",
    alt: "twitter",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/twitter.svg",
    content: "Publishing + DM + Listening ",
  },
  {
    id: 8,
    title: "Google My Business",
    alt: "gmb",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/Gmb.svg",
    content: "Publishing",
  },
  {
    id: 9,
    title: "Google Analytics",
    alt: "google-analytics",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/googleAnalytics.svg",
    content: "Metrics",
  },
  {
    id: 10,
    title: "Google Business Messaging",
    alt: "gbm",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/GBMupdate.png",
    content: "DM",
  },
  {
    id: 11,
    title: "Google Drive",
    alt: "google-drive",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/googleDrive.svg",
    content: "Content Retrieval + Collaboration",
  },
  {
    id: 12,
    title: "Medium",
    alt: "e-mail",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/Medium-Logo-Black-RGB_300x80.svg",
    content: "Publishing",
  },
  {
    id: 13,
    title: "E-mail",
    alt: "e-mail",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/mail.svg",
    content: "Responding",
  },
  {
    id: 14,
    title: "Crello",
    alt: "crello",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/crelloc.png",
    content: "Content Creation",
  },
  {
    id: 15,
    title: "Pixabay",
    alt: "pixabay",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/pixabay.svg",
    content: "Media Discovery",
  },
];
